<div class="d-flex h-100 bg-light-subtle w-100">
  <div class="p-3 left-sidebar-wrapper">
    <ng-content select="[slot=left-sidebar]"></ng-content>
  </div>

  <div class="main-wrapper h-100 overflow-auto">
    <ng-content select="[slot=main]"></ng-content>
  </div>
</div>
